export const CENTER = 'center';
export type TCenter = typeof CENTER;
export const LEFT = 'left';
export type TLeft = typeof LEFT;
export const RIGHT = 'right';
export type TRight = typeof RIGHT;
export const TOP = 'top';
export type TTop = typeof TOP;
export const BOTTOM = 'bottom';
export type TBottom = typeof BOTTOM;
